import AssessiveLogo from "../Custom/AssessiveLogo";
import RightContent from "./RightContent";


const AccessContainer = ({ children }) => {
  return (
    <span className="access-container">
      <AssessiveLogo />
      {children}
      <RightContent />
    </span>
  );
};

export default AccessContainer;
